export const getUrlWithParam = (name, value, baseUrl = window.location.href) => {
  const param = `${name}=${value}`;
  if (baseUrl.indexOf('?') > -1) {
    return `${baseUrl}&${param}`;
  }
  return `${baseUrl}?${param}`;
};
